import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-810380f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "filters"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kies een project om de bijbehorende bouwnummers te laden.", -1))
const _hoisted_3 = { class: "selection-area" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Geen bouwnummers gevonden voor dit project.", -1))

import { onMounted, ref, computed } from 'vue'
import { HomeFilled, LoadingOutlined } from '@ant-design/icons-vue'
import axios from 'axios'
import { authStore } from '@/stores/auth'
import { headerStore } from '@/stores/header'
import { useRoute, useRouter } from 'vue-router'
import SecureLS from 'secure-ls'
import { permissions } from '@/globalVariables'
import { Building } from '@/types/building'

interface BuildingConfig {
  cid:number,
  customer_id:number,
  customer:string,
  is_demo:boolean,
}

interface BuildingConfigGroup {
  bid:number
  number:number
  address:string|null
  zipcode:string|null
  city:string|null
  configs:BuildingConfig[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRelatedBuildingSelector',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const ls = new SecureLS({ isCompression: false })
const loading = ref<number|boolean>(false)
const projects = ref<{ id:number, name:string }[]>([])
const selectedProjectId = ref<number|null>(ls.get('buildingSelectorProjectId') || null)
const buildings = ref<BuildingConfigGroup[]>([])
const filterTypes = ['demo', 'bought']
const typeFilter = ref<string[]>(['bought', 'demo'])

const showDemoBuildings = computed(() => {
  return authStore().hasPermission(permissions.VIEW_DEMO_BUILDINGS) && typeFilter.value.includes('demo')
})
const showSoldBuildings = computed(() => {
  return authStore().hasPermission(permissions.VIEW_SOLD_BUILDINGS) && typeFilter.value.includes('bought')
})

onMounted(() => {
  getProjects()
})

const buildingCollection = computed(() => {
  return buildings.value.map((building) => {
    return {
      ...building,
      configs: building.configs.filter((config) => {
        if (showDemoBuildings.value && showSoldBuildings.value) {
          return true
        } else if (showSoldBuildings.value) {
          return !config.is_demo
        } else if (showDemoBuildings.value) {
          return config.is_demo
        }
        return false
      })
    }
  }).filter((building) => building.configs.length > 0)
})

function filterProjects (input: string, option: { key: number, value: number }) : boolean {
  const p = projects.value.find((project) => project.id === option.value)
  return p ? p.name.toLowerCase().includes(input.toLowerCase()) : false
}

function getProjects () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/projects').then((response) => {
    projects.value = response.data.map((p: { id:number, reference:string }) => ({
      id: p.id,
      name: p.reference
    })).sort((a:{id:number, name:string}, b:{id:number, name:string}) => a.name.localeCompare(b.name))
  }).catch((error) => {
    console.error('Error fetching projects:', error)
  }).finally(() => {
    loading.value = false
    onProjectSelected(selectedProjectId.value)
  })
}

function onProjectSelected (id: number) : void {
  if (!id) return
  buildings.value = []
  loading.value = true
  selectedProjectId.value = id
  ls.set('buildingSelectorProjectId', id)
  axios.get(process.env.VUE_APP_API_URL + '/projects/' + id + '/buildings', {
    params: { projectId: id }
  }).then((res) => {
    buildings.value = res.data
  }).catch((error) => {
    console.error('Error fetching buildings:', error)
  }).finally(() => {
    loading.value = false
  })
}

function selectConfig (buildingId:number, cid: number, isDemo: boolean) : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/building/config', { buildingId: buildingId, cid: cid, demo: isDemo }).then((r) => {
    authStore().setCurrentBuilding(r.data as Building)
    headerStore().getOrdersReceived()
    headerStore().checkIfExtraPhaseIsEnabled()
    headerStore().checkIfServiceIsEnabled()

    if (route.query.redirect && typeof route.query.redirect === 'string') {
      router.push({ path: route.query.redirect })
    } else {
      router.push({ name: 'Dashboard' })
    }
  }).finally(() => {
    loading.value = false
  })
}

function toggleFilter (type: string) : void {
  if (typeFilter.value.includes(type)) {
    typeFilter.value = typeFilter.value.filter(t => t !== type)
  } else {
    typeFilter.value.push(type)
  }
  if (typeFilter.value.length === 0) {
    typeFilter.value = filterTypes.filter(t => t !== type)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Selecteer een project.",
            bordered: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    offset: 8,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: selectedProjectId.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedProjectId).value = $event)),
                        style: {"width":"100%"},
                        placeholder: "Selecteer een project",
                        "show-search": true,
                        "filter-option": filterProjects,
                        onChange: onProjectSelected
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: project.íd,
                              value: project.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(project.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, {
            title: "Bouwnummers",
            bordered: false,
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              (buildings.value.length && selectedProjectId.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: 16,
                    style: {"margin-bottom":"24px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(authStore)().hasPermission(_unref(permissions).VIEW_SOLD_BUILDINGS) && _unref(authStore)().hasPermission(_unref(permissions).VIEW_DEMO_BUILDINGS))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (_unref(authStore)().hasPermission(_unref(permissions).VIEW_SOLD_BUILDINGS))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["filter bought", {'disabled': !typeFilter.value.includes('bought')}]),
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleFilter('bought')))
                                    }, [
                                      _createVNode(_unref(HomeFilled)),
                                      _createTextVNode(" Gekocht ")
                                    ], 2))
                                  : _createCommentVNode("", true),
                                (_unref(authStore)().hasPermission(_unref(permissions).VIEW_DEMO_BUILDINGS))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(["filter demo", {'disabled': !typeFilter.value.includes('demo')}]),
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleFilter('demo')))
                                    }, [
                                      _createVNode(_unref(HomeFilled)),
                                      _createTextVNode(" Demo's ")
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!selectedProjectId.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 1,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (loading.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 2,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_skeleton, {
                            active: "",
                            rows: 3
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!loading.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 3,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildings.value, (building, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "config-groups",
                                key: index
                              }, [
                                _createVNode(_component_a_card, { class: "config-card" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_card_meta, {
                                      title: `Bouwnummer ${building.number}`
                                    }, {
                                      description: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(building.address && building.zipcode && building.city ? `${building.address}, ${building.zipcode} ${building.city}` : 'Adres (nog) niet bekend.') + " ", 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(building.configs, (config) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["config-option", { 'disabled': (config.is_demo && !_unref(showDemoBuildings)) || (!config.is_demo && !_unref(showSoldBuildings)) }]),
                                            key: config.cid,
                                            onClick: ($event: any) => (selectConfig(building.bid, config.cid, config.is_demo))
                                          }, [
                                            _createVNode(_unref(HomeFilled), {
                                              class: _normalizeClass(["icon", { 'is-demo': config.is_demo }])
                                            }, null, 8, ["class"]),
                                            (loading.value === config.cid)
                                              ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                                                  key: 0,
                                                  style: {"margin-right":"8px"}
                                                }))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", null, _toDisplayString(config.customer), 1)
                                          ], 10, _hoisted_4))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["title"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!loading.value && buildings.value.length === 0 && selectedProjectId.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 4,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})